import React from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

export const SortHeader = ({ label, sortKey, currentKey, currentDir, onSort, className = '', align = 'left' }) => {
  const isActive = currentKey === sortKey;
  const alignClass = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';
  return (
    <th
      className={`px-3 py-3 font-semibold text-[#0A2540] cursor-pointer select-none hover:bg-[#E2E8F0] transition-colors ${className}`}
      onClick={() => onSort(sortKey)}
      data-testid={`sort-${sortKey}`}
    >
      <div className={`flex items-center gap-1 ${alignClass}`}>
        <span>{label}</span>
        {isActive ? (
          currentDir === 'asc' ? <ArrowUp className="h-3 w-3 text-[#0A2540]" /> : <ArrowDown className="h-3 w-3 text-[#0A2540]" />
        ) : (
          <ArrowUpDown className="h-3 w-3 text-[#94A3B8]" />
        )}
      </div>
    </th>
  );
};
